<template>
  <CContainer fluid>
    <CRow>
      <div>DEV PAGE</div>
    </CRow>
    <CRow>
      <CCol col="12">
        <CCard>   
            <table style="border: 1px solid black;">
              <thead>
                <tr>
                  <th>id</th>
                  <th>name</th>
                  <th>publish</th>
                  <th>active</th>
                  <th>req class</th>
                  <th>batch template</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(i) in data_class_index" :key="i.index" style="border: 1px solid black;">
                  <td>{{ i.id }}</td>
                  <td>{{ i.name }}</td>
                  <td>{{ i.is_publish }}</td>
                  <td>{{ i.is_active }}</td>
                  <td>{{ i.required_class }}</td>
                  <td>
                    <table style="border: 1px solid black;">
                        <thead>
                            <tr>
                                <th>id</th>
                                <th>name</th>
                                <th>publish</th>
                                <th>active</th>
                                <th>schedule</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(j) in i.class_batch_template" :key="j.index" style="border: 1px solid black;">
                                <td>{{ j.class_template.id }}</td>
                                <td>{{ j.class_template.name }}</td>
                                <td>{{ j.class_template.is_publish }}</td>
                                <td>{{ j.class_template.is_active }}</td>
                                <td>
                                    <table style="border: 1px solid black;">
                                        <thead>
                                            <tr>
                                                <th>id</th>
                                                <th>pub_date</th>
                                                <th>class_date</th>
                                                <th>status</th>
                                                <th>active</th>
                                                <th>action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(k) in j.class_template.class_schedule" :key="k.index" style="border: 1px solid black;">
                                                <td>{{ k.id }}</td>
                                                <td>{{ k.publish_date }}</td>
                                                <td>{{ k.class_date }}</td>
                                                <td>{{ k.status }}</td>
                                                <td>{{ k.is_active }}</td>
                                                <td><CButton variant="primary" color="success" @click="detail(i.id, j.class_template.id, k.id)">detail</CButton></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>    
                            </tr>
                        </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
        </CCard>
      </CCol>
    </CRow>
<pre>{{ $data }}</pre>
  </CContainer>
</template>

<script>

import dev_service from "@/services/dev";
export default {

  components: {  },

  data () {
    return {
        data_class_index: []
    }
  },

  mounted(){
      this.loadData();
  },


  methods: {
      loadData() {            
         dev_service.getClassIndex()
            .then((res) => {
                console.log(res);
               this.data_class_index = res.data;
            })
            .catch((err) => {
               alert(err.response.data.message);
            });              

      },
      detail(bID, tID, sID) {
        //this.$router.push({ name: "Schedule Detail", query: { id: kID } });
        this.$router.push({ name: "Dev Page Class Schedule Detail Attendace", query: { bid: bID, tid: tID, sid: sID } });
        //   let routeData = this.$router.resolve({
        //     path: "/dev_page/class/schedule_detail_attendance?sid=".kID,
        //  });
        //  window.open(routeData.href, "_blank");
      },
      show_attendance: function() {
         let routeData = this.$router.resolve({
            path: "/schedule_detail_attendance",
         });
         window.open(routeData.href, "_blank");
      },
  }
}
</script>
